export default "__VITE_ASSET__30a36146__"